import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../utils/Utils";
import Calendar from "../../../../../../../components/calendar/Calendar";
import $ from "jquery";

class CasoSospetto extends Component {

    state = {
        casoSospetto: {
            caso: "",
            tipoInvio: "",
            eventualeData: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.disabledCalendar = this.disabledCalendar.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let casoSospetto = this.state.casoSospetto

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.casoSospetto) {
            let casoSospettoCopia = this.props.segnalazioneCopia.schedaSpeciale.casoSospetto
            casoSospetto.caso = casoSospettoCopia.caso ? casoSospettoCopia.caso : ""
            casoSospetto.tipoInvio = casoSospettoCopia.tipoInvio ? casoSospettoCopia.tipoInvio : ""
            casoSospetto.eventualeData = casoSospettoCopia.eventualeData ? casoSospettoCopia.eventualeData : ""

        } else {
            if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.malattia === Utils.mapMalattieDescrizione("Morbillo")) {
                casoSospetto.caso = "1"
            } else if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.malattia === Utils.mapMalattieDescrizione("Rosolia")) {
                casoSospetto.caso = "2"
            }
        }
        this.setState({casoSospetto: casoSospetto})
        this.disabledCalendar()
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloCorrettezza()
        this.props.createOggettoBeAndcontrolloCorrettezza("casoSospetto", oggettoBE, corretto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledCalendar()

        if (prevState !== this.state) {
            let res = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("casoSospetto", res, corretto, this.validate())
        }
    }

    validate() {

        if (this.state.casoSospetto.eventualeData && Utils.validateDate(this.state.casoSospetto.eventualeData, "Messages.CasoSospetto", "Messages.CasoSospettoOdierna")) {
            return Utils.validateDate(this.state.casoSospetto.eventualeData, "Messages.CasoSospetto", "Messages.CasoSospettoOdierna")
        }

        return ""

    }

    disabledCalendar() {
        if (this.state.casoSospetto.tipoInvio !== "2") {
            $(document).ready(function () {
                $("#eventualeData").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#eventualeData").datepicker('enable');
            })
        }
    }

    riceviValore(field, event) {
        let casoSospetto = this.state.casoSospetto
        casoSospetto[field] = event.target.value
        if (casoSospetto.tipoInvio === "1") {
            casoSospetto.eventualeData = ""
        }
        this.setState({casoSospetto: casoSospetto})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloCorrettezza()
        this.props.createOggettoBeAndcontrolloCorrettezza("casoSospetto", oggettoBE, corretto)
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.casoSospetto))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let casoSospetto = this.state.casoSospetto
        casoSospetto.corretto = []

        if((casoSospetto.tipoInvio === "2" && !casoSospetto.eventualeData) || (casoSospetto.eventualeData && Utils.isDateInValid(Utils.transformDateForBackend(casoSospetto.eventualeData), "-"))) casoSospetto.corretto[0] = "Campo \"Aggiornamento alla data\" mancante o errato";

        return casoSospetto.corretto
    }


    render() {

        const {t} = this.props

        const casoSospetto = (

            <div className={"row"}>
                <div className={"col-lg-2"}>
                    <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                        {t("SchedaSpecialeMorbillo.casoSospetto")}
                    </p>
                </div>
                <div className={"col-lg-10"}>
                    <div className={"row"}>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"casoSospettoMorbillo"} name={"caso"}
                                         label={t("SchedaSpecialeMorbillo.morbillo")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.casoSospetto.caso === "1"}>
                            </RadioButton>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"casoSospettoRosolia"} name={"caso"}
                                         label={t("SchedaSpecialeMorbillo.rosolia")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.casoSospetto.caso === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"casoSospettoPrimoInvio"} name={"tipoInvio"}
                                         label={t("SchedaSpecialeMorbillo.primoInvio")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.casoSospetto.tipoInvio === "1"}>
                            </RadioButton>
                        </div>
                        <div className={"col-lg-6"}>
                            <div className={"row"}>
                                <div className={"col-lg-7"}>
                                    <RadioButton id={"casoSospettoAggiornamento"} name={"tipoInvio"}
                                                 label={t("SchedaSpecialeMorbillo.aggiornamentoAllaData")}
                                                 style={{color: "black", fontSize: "16px"}}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true} value={"2"}
                                                 checked={this.state.casoSospetto.tipoInvio === "2"}>
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-5"}
                                >
                                    <Calendar
                                        id={"eventualeData"}
                                        value={this.state.casoSospetto.eventualeData}
                                        field={"eventualeData"}
                                        newCalendar={true}
                                        required={this.state.casoSospetto.tipoInvio === "2"}
                                        disabled={this.state.casoSospetto.tipoInvio === "2" ? false : true}
                                        onChange={this.riceviValore}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                            t("SchedaSpecialeMorbillo.aggiornamentoAllaData"))}
                                        error={(this.state.casoSospetto.eventualeData == "" ||
                                            this.state.casoSospetto.eventualeData == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.casoSospetto.eventualeData), "-")}
                                    >
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )


        return (
            <div className={"container"}>
                {casoSospetto}
            </div>
        );
    }

}

export default withTranslation('common')(CasoSospetto)
